export default __webpack_public_path__ + "static/media/live.6b0c2855.png";